module.exports = __webpack_public_path__ + "static/media/BT.c8af8097.png";